import React from "react";

const SidebarWidget = ({ title, viewMore, children, onTipClick }) => {
  return (
    <div className="sidebar-widget">
      <div className="widget-title">
        <h2>{title}</h2>
        {viewMore && <>{viewMore}</>}
      </div>
      {React.Children.map(children, child =>
        React.cloneElement(child, { onTipClick })
      )}
    </div>
  );
};

export default SidebarWidget;
